import {
    CustomSeriesPricePlotValues,
    ICustomSeriesPaneView,
    PaneRendererCustomData,
    Time,
    WhitespaceData
} from 'lightweight-charts'
import { defaultOptions, HlcAreaSeriesOptions } from './options'
import { HlcAreaSeriesSeriesRenderer } from './renderer'
import { HlcAreaData } from './data'


export class HlcAreaSeries<TData extends HlcAreaData>
    implements ICustomSeriesPaneView<Time, TData, HlcAreaSeriesOptions> {
    _renderer: HlcAreaSeriesSeriesRenderer<HlcAreaData>
    constructor() {
        this._renderer = new HlcAreaSeriesSeriesRenderer()
    }

    priceValueBuilder(plotRow: HlcAreaData): CustomSeriesPricePlotValues {
        return [plotRow.close]
    }

    isWhitespace(data: HlcAreaData | WhitespaceData): data is WhitespaceData {
        return (data as Partial<TData>).close === undefined
    }

    renderer(): HlcAreaSeriesSeriesRenderer<HlcAreaData> {
        return this._renderer
    }

    update(
        data: PaneRendererCustomData<Time, HlcAreaData>,
        options: HlcAreaSeriesOptions
    ): void {
        this._renderer.update(data, options)
    }

    defaultOptions() {
        return defaultOptions
    }
}
